'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _nav = require('../actions/nav');

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { selectedKey: 'home' };
    var action = arguments[1];

    switch (action.type) {
        case _nav.SELECT_NEMU:
            {
                return _extends({}, state, {
                    selectedKey: action.key
                });
            }
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/nav.js
// module id = 895
// module chunks = 0